export enum BoatStatus {
    SAILING = 'SAILING',
    MOORED = 'MOORED',
    PREPARED = 'PREPARED',
    WAITING_PREPARATION = 'WAITING_PREPARATION',
    STORED = 'STORED'
}
